import { useState, useEffect } from 'react';
import routes from '../../api/index'

export default function Edit(props) {
    const { book, handleUpdateBook, setDisplayPopup, handleAddJournal, filterJournals } = props

    const [bookTitle, setBookTitle] = useState(book.name)
    const [status, setStatus] = useState(book.status)
    const [page, setPage] = useState(book.currentPage)

    const [journalTitle, setJournalTitle] = useState("Untitled")
    const [journalContent, setJournalContent] = useState("Untitled")


    const popupStyle = {
        position: "absolute",
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        height: "100vh",
        width: "100vw",
        left: 0,
        top: 0,
    }

    const inputStyle = {
        paddingTop: 2,
        paddingBottom: 2,
        borderBottomWidth: 3,
        borderColor: (book.status === "In Progress" ? "antiquewhite" : "#9AC791"),
        display: "inline",
    }

    const EditBookInfo = () => {
        return <div className="mx-10 mt-10">
            <div className={"booklist-title" + (book.status === "In Progress" ? " in-progress-title " : " completed-title ")}> Edit Book Info</div>
            <div className="">
                <div className="block sm:inline">
                    <label className="font-light text-sm mr-2 font-bold">Title</label>
                    <input
                        style={inputStyle}
                        id="book-title-input"
                        onChange={e => setBookTitle(e.target.value)}
                        required className="focus:outline-none mr-5" type="text" defaultValue={book.name}></input>
                </div>

                <div className="block sm:inline">
                    <label className="font-light text-sm mr-2 font-bold">Status</label>
                    <select
                        style={inputStyle}
                        id="book-status-input"
                        onChange={e => setStatus(e.target.value)}
                        required className="focus:outline-none mr-5" type="text">
                        <option selected>{book.status}</option>
                        <option>{book.status === "In Progress" ? "Completed" : "In Progress"}</option>
                    </select>
                </div>

                <div className="block sm:inline">
                    <label className="font-light text-sm mr-2 font-bold">Page</label>
                    <input
                        style={inputStyle}
                        id="book-page-input"
                        onChange={e => setPage(e.target.value)}
                        required className="focus:outline-none w-10 mr-5 text-center"
                        type="number"
                        defaultValue={book.currentPage}></input>
                </div>

                <button style={inputStyle} className="my-2"
                    onClick={() => { handleUpdateBook(book, bookTitle, status, page); }}>Save</button>

            </div>
        </div>
    }

    const Journal = () => {
        return <div className="mx-10 mt-10">
            <div className={"booklist-title mb-2" + (book.status === "In Progress" ? " in-progress-title " : " completed-title ")}>Write</div>

            <div>
                <label className="font-light text-sm mr-2 font-bold">Journal Title</label>
                <input style={inputStyle} onChange={e => setJournalTitle(e.target.value)}
                    className="focus:outline-none mb-2" type="text"
                    placeholder="Untitled"></input><br></br>
                <label className="font-light text-sm mr-2 font-bold">Content</label><br></br>
                <textarea
                    id="journal-input"
                    onChange={e => setJournalContent(e.target.value)}
                    style={inputStyle}
                    className="mb-2 focus:outline-none focus:bg-gray-100 w-full sm:w-1/3"></textarea> <br></br>
                <button onClick={() => {
                    handleAddJournal(book.name, journalTitle, journalContent)
                    document.getElementById("journal-input").value=""
                }
                } className="font-bold" style={inputStyle}>Create</button>
            </div>
        </div>
    }

    const ViewJournals = () => {
        return <div className="mx-10 mt-10">
            <div className={"booklist-title mb-2" + (book.status === "In Progress" ? " in-progress-title " : " completed-title ")}>Your Journals</div>

            <div>
                {filterJournals(book.name)}
            </div>
        </div>
    }


    return <div style={popupStyle} className="pt-10 px-40">
        <div className="cursor-pointer" onClick={() => setDisplayPopup(false)}>X</div>
        {EditBookInfo()}
        {Journal()}
        {ViewJournals()}
    </div>
}